
export const ACTION_GET_BONUS = "ACTION_GET_BONUS";
export const ACTION_POST_CREATE_BONUS = "ACTION_POST_CREATE_BONUS";
export const ACTION_PUT_UPDATE_BONUS = "ACTION_PUT_UPDATE_BONUS";
export const ACTION_DELETE_BONUS = "ACTION_DELETE_BONUS";